import { Comparisons } from "../Form/Form";
import { Emoji } from 'emoji-picker-react';
import ReactDOM from 'react-dom/client';

export class ViewDetailsCellRenderer {
  init(params) {
    this.params = params;

    this.eGui = document.createElement('div');
    this.eGui.style = "display: flex; align-items: center";

    var icon = document.createElement("span");
    icon.className = "bi bi-zoom-in";
    icon.addEventListener('click', function () {
      params.colDef.cellEditorParams.viewDetails(params.value.id || params.data.ID);
    });
    icon.title = params.colDef.cellEditorParams.iconTooltip || "View Submission Details";
    icon.style = "cursor: pointer; font-size: 18px; padding-right: 4px;";

    var text = document.createElement("div");
    text.innerText = params.value.value ? params.value.value : params.value;
    text.style = "display: inline-block;";

    this.eGui.append(icon);
    this.eGui.append(text);
  }

  getGui() {
    return this.eGui;
  }
}

export class AgeCellRenderer {
  init(params) {
    this.params = params;
    this.eGui = document.createElement('div');
    
    var newColor = "var(--green)";
    var midColor = "var(--yellow)";
    var oldColor = "var(--red)";


    this.eGui.title = `${params.value} day(s) since last update.`;

    if (params.value == null) {
      this.eGui.setAttribute("style", `background-color: ${newColor}; height: 15px; width: 15px; border-radius: 7px; margin: 4px;`);
      this.eGui.title = `Completed.`;
    } else if (params.value < 14) {
      this.eGui.setAttribute("style", `background-color: ${newColor}; height: 15px; width: 15px; border-radius: 7px; margin: 4px;`);
    } else if (params.value < 21) {
      this.eGui.setAttribute("style", `background-color: ${midColor}; height: 15px; width: 15px; border-radius: 7px; margin: 4px;`);
    } else {
      this.eGui.setAttribute("style", `background-color: ${oldColor}; height: 15px; width: 15px; border-radius: 7px; margin: 4px;`);
    }
  }

  getGui() {
    return this.eGui;
  }
}

export class EmojiCellRenderer {
  init(params) {
    this.params = params;
    this.eGui = document.createElement('div');

    var emoji = <Emoji unified={params.value} />

    this.root = ReactDOM.createRoot(this.eGui);
    this.root.render(emoji);
  }

  getGui() {
    return this.eGui;
  }
  
  destroy() {
    if (this.root) {
      setTimeout(() => this.root.unmount(), 0);
    }
  }
}

export class StaticLinkRenderer {	
    init(params) {
      this.params = params;

      var icon = document.createElement('span');

      icon.className = "bi bi-link-45deg";
      icon.addEventListener('click', function () {
        navigator.clipboard.writeText(params.value);
        alert("Static link copied!");
      });
      icon.title = "Copy to clipboard";
      icon.style = "cursor: pointer; font-size: 22px; padding-right: 4px";

      var iconQrCode = document.createElement('span');

      iconQrCode.className = "bi bi-qr-code";
      iconQrCode.addEventListener('click', function () {
        params.colDef.cellEditorParams.generateQrCode(params.value);
      });
      iconQrCode.title = "View QR Code";
      iconQrCode.style = "cursor: pointer; font-size: 22px; padding-right: 4px";

      this.eGui = document.createElement('span');
      this.eGui.style = "display: inline-flex;";
      
      this.eGui.innerText = params.value;
      this.eGui.prepend(iconQrCode);
      this.eGui.prepend(icon);
    }
    
    getGui() {
      return this.eGui;
    }
}

export class YesNoCellRenderer {	
    init(params) {
      this.params = params;

      this.eGui = document.createElement('span');

      if (params.value === "NO") {
        this.eGui.setAttribute("style", "color: var(--red)");
      } else if (params.value === "YES") {
        this.eGui.setAttribute("style", "color: green");
      }
      
      this.eGui.innerText = params.value;
    }
    
    getGui() {
      return this.eGui;
    }
}

export class FullWidthCellRenderer {
  init(params) {
    this.eGui = document.createElement('div');
    this.render(params);
  }

  render(params) {
    this.params = params;
    this.eGui.innerHTML = "";
    this.eGui.setAttribute("style", "display: flex; align-items: center; padding: 8px 5px; height: 100%;");

    var editBtn = document.createElement("button");
    editBtn.setAttribute("style", "margin-right: 5px; padding: 2px 6px; font-size: 12px;");
    editBtn.setAttribute("class", `btn btn-sm btn-primary bi-pencil`);
    editBtn.setAttribute("type", "button");
    editBtn.setAttribute("title", "Edit Page Summary");
    editBtn.addEventListener("click", () => {
      this.params.data.editSummary(this.params.data.Page);
    });

    var addBtn = document.createElement("button");
    addBtn.setAttribute("style", "margin-right: 5px; padding: 2px 6px; font-size: 12px;");
    addBtn.setAttribute("class", `btn btn-sm btn-success bi-plus-lg`);
    addBtn.setAttribute("type", "button");
    addBtn.setAttribute("title", "Add Question to Page");
    addBtn.addEventListener("click", () => {
      this.params.data.addQuestionToPage(this.params.data.Page);
    });

    var deleteBtn = document.createElement("button");
    deleteBtn.setAttribute("style", "margin-right: 10px; padding: 2px 6px; font-size: 12px;");
    deleteBtn.setAttribute("class", `btn btn-sm btn-danger bi-trash`);
    deleteBtn.setAttribute("type", "button");
    deleteBtn.setAttribute("title", "Delete Page");
    deleteBtn.addEventListener("click", () => {
      this.params.data.deletePage(this.params.data.Page);
    });
    
    var pageText = document.createElement("span");
    pageText.setAttribute("style", "color: #333; font-size: 14px;");
    
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = params.data.PageSummary;
    var firstP = tempDiv.querySelector('p');
    var summaryText = firstP ? firstP.textContent : params.data.PageSummary;
    
    pageText.innerHTML = `<b>Page:</b> ${params.data.Page + 1}, ${summaryText}`;
    
    this.eGui.appendChild(editBtn);
    this.eGui.appendChild(addBtn);
    if (params.data.canDeletePage !== false) {
      this.eGui.appendChild(deleteBtn);
    }
    this.eGui.appendChild(pageText);
  }

  refresh(params) {
    this.render(params);
    return true;
  }

  getGui() {
    return this.eGui;
  }
}

// TODO: update to include orGroups
export class VisibilityCellRenderer {
  init(params) {
    this.params = params;

    var always = this.params.data.Visibility.length == 0 || this.params.data.Visibility?.some(v => v?.Comparison == Comparisons.ALWAYS);
    var never = !always && this.params.data.Visibility?.some(v => v?.Comparison == Comparisons.NEVER);
    var comparisonIcon = "";

    if (always || never) {
      comparisonIcon = always ? "bi-check-lg" : "bi-x-lg";
    }
    
    this.eGui = document.createElement('div');
    this.eGui.setAttribute('style', "margin-top: 6px; width: 100%; height: 100%");

    var o = document.createElement("button");
    o.setAttribute("class", `btn btn-sm btn-primary bi-eye`);
    o.setAttribute("type", "button");

    this.eGui.appendChild(o);

    var count = document.createElement("span");
    
    count.setAttribute("style", "font-size: small; font-weight: 200; float: right;");
    count.innerText = this.params.data.Visibility.length ? this.params.data.Visibility.length : "-";

    if (always || never) {
      var i = document.createElement("span");
      
      i.setAttribute("class", ` ${comparisonIcon}`);
      i.setAttribute("style", "font-size: large; float: right;");
      i.appendChild(count);

      this.eGui.appendChild(i);
    } else {
      this.eGui.appendChild(count);
    }
  }

  getGui() {
    return this.eGui;
  }
}

export class QuestionOptionsCellRenderer {
  init(params) {
    this.params = params;

    if (this.params.data.Type != "SINGLE"
      && this.params.data.Type != "MULTI"
      && this.params.data.Type != "MULTI_BUTTONS"
      && this.params.data.Type != "SINGLE_BUTTONS")
    {
      this.eGui = document.createElement('div');
      var na = document.createElement("span");

      na.innerText = "N/A";
      
      this.eGui.appendChild(na);
    } else {
      var icon = "bi-list-task";
      
      this.eGui = document.createElement('div');
      const button = document.createElement('div');
      button.setAttribute('class', "btn-group")
      button.setAttribute('style', "margin-top: 6px")

      var o = document.createElement("button");

      o.setAttribute("class", `btn btn-sm btn-primary ${icon}`);
      o.setAttribute("type", "button");
      var count = document.createElement("span");
      
      count.setAttribute("style", "font-size: small; font-weight: 200; margin-left: 5px;");
      count.innerText = this.params.data.Options.length;
      
      button.appendChild(o);
      this.eGui.appendChild(button);
      this.eGui.appendChild(count);
    }
  }

  getGui() {
    return this.eGui;
  }
}

export class QuestionTextCellRenderer {
  init(params) {
    this.params = params;

    this.eGui = document.createElement('div');
    var o = document.createElement("span");

    o.innerHTML = this.params.data.Text;
    
    this.eGui.appendChild(o);
  }

  getGui() {
    return this.eGui;
  }
}

export class HelpTextCellRenderer {
  init(params) {
    this.params = params;

    this.eGui = document.createElement('div');
    var o = document.createElement("span");

    o.innerHTML = this.params.data.HelpText ?? "";
    
    this.eGui.appendChild(o);
  }

  getGui() {
    return this.eGui;
  }
}

// TODO: update to include orGroups
export class RequiredCellRenderer {
  init(params) {
    this.params = params;

    var always = this.params.data.Required?.some(v => v?.Comparison == Comparisons.ALWAYS);
    var never = !always && this.params.data.Required?.some(v => v?.Comparison == Comparisons.NEVER);
    var comparisonIcon = "";

    if (always || never) {
      comparisonIcon = always ? "bi-check-lg" : "bi-x-lg";
    }
    
    this.eGui = document.createElement('div');
    this.eGui.setAttribute('style', "margin-top: 6px; width: 100%; height: 100%");

    var o = document.createElement("button");
    o.setAttribute("class", `btn btn-sm btn-primary bi-lock`);
    o.setAttribute("type", "button");

    this.eGui.appendChild(o);

    var count = document.createElement("span");
      
    count.setAttribute("style", "font-size: small; font-weight: 200; float: right;");
    count.innerText = this.params.data.Required.length ? this.params.data.Required.length : "-";

    if (always || never) {
      var i = document.createElement("span");
      
      i.setAttribute("class", ` ${comparisonIcon}`);
      i.setAttribute("style", "font-size: large; float: right;");
      i.appendChild(count);

      this.eGui.appendChild(i);
    } else {
      this.eGui.appendChild(count);
    }
  }

  getGui() {
    return this.eGui;
  }
}

export class ValidationCellRenderer {
  init(params) {
    this.params = params;
    
    this.eGui = document.createElement('div');
    const button = document.createElement('div');

    button.setAttribute('class', "btn-group")
    button.setAttribute('style', "margin-top: 6px")

    var icon = "bi-shield-fill-check";

    var o = document.createElement("button");

    o.setAttribute("class", `btn btn-sm btn-primary ${icon}`);
    o.setAttribute("type", "button");

    var count = document.createElement("span");
    
    count.setAttribute("style", "font-size: small; font-weight: 200; margin-left: 5px;");
    count.innerText = this.params.data.Validations.length ? this.params.data.Validations.length : "-";

    button.appendChild(o)
    this.eGui.appendChild(button);
    this.eGui.appendChild(count);
  }

  getGui() {
    return this.eGui;
  }
}

export class InterpretationsCellRenderer {
  init(params) {
    this.params = params;

    const icon = "bi-journal-check";
    
    this.eGui = document.createElement('div');
    const button = document.createElement('div');

    button.setAttribute('class', "btn-group");
    button.setAttribute('style', "margin-top: 6px");

    var o = document.createElement("button");

    o.setAttribute("class", `btn btn-sm btn-primary ${icon}`);
    o.setAttribute("type", "button");

    var count = document.createElement("span");
    
    count.setAttribute("style", "font-size: small; font-weight: 200; margin-left: 5px;");
    count.innerText = this.params.data.Interpretations.length > 0 ? this.params.data.Interpretations.length : "-";

    button.appendChild(o)
    this.eGui.appendChild(button);
    this.eGui.appendChild(count);
  }

  getGui() {
    return this.eGui;
  }
}

export class AllRulesCellRenderer {
  init(params) {
    this.params = params;
    
    this.eGui = document.createElement('div');

    this.eGui.setAttribute('class', "btn-group")
    this.eGui.setAttribute('style', "margin-top: 6px")

    var icon = "bi-eyeglasses";

    var o = document.createElement("button");

    o.setAttribute("class", `btn btn-sm btn-primary ${icon}`);
    o.setAttribute("type", "button");
    o.addEventListener("click", () => {

    })

    this.eGui.appendChild(o);
  }

  getGui() {
    return this.eGui;
  }
}